import { render, staticRenderFns } from "./StrategyGroup.vue?vue&type=template&id=c50635e2&"
import script from "./StrategyGroup.vue?vue&type=script&lang=ts&"
export * from "./StrategyGroup.vue?vue&type=script&lang=ts&"
import style0 from "./StrategyGroup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports